import {
  styled,
  Dialog,
  dialogClasses,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import { TabPanel, LoadingButton } from '@mui/lab';

export const DialogAssingBillingListContainer = styled(Dialog)({
  [`& .${dialogClasses.paper}`]: {
    maxWidth: 560,
    width: '100%',
    minHeight: 365,
  },
});

export const DialogAssingBillingListLoadingContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  flex: 1,
});

export const DialogAssingBillingListContentContainer = styled(DialogContent)({
  display: 'flex',
  flex: 1,
});

export const DialogAssingBillingListTabPanel = styled(TabPanel)({
  display: 'flex',
  padding: 0,
  flex: 1,
  height: '100%',
});

export const DialogAssingBillingListActions = styled(DialogActions)({
  justifyContent: 'space-between',
});

export const DialogAssingBillingListActionsButton = styled(Button)({
  minWidth: 100,
});

export const DialogAssingBillingListActionsButtonLoading = styled(
  LoadingButton,
)({
  minWidth: 100,
});
